import React, { useState, useEffect } from "react";
import logo from "../assets/images/signup_icons/logo-dark.svg";
import google from "../assets/images/signup_icons/google-color.svg";
import facebook from "../assets/images/signup_icons/face.svg";
import emailicon from "../assets/images/signup_icons/email.svg";
import lockicon from "../assets/images/signup_icons/lock.svg";
import { Link, useLocation } from "react-router-dom";
import FormInput from "../components/Forms/FormInput";
// import classes from "../assets/styles/Login.module.css";
import {
  COUPON_LOGIN,
  GET_USER_SUBSCRIPTION,
  LINKEDIN_AUTH,
  LOGIN,
  SOCIAL_LOGIN,
} from "../utils/constants/apiUrl";
import { get, post } from "../server";
import { useAtom } from "jotai";
import {
  loggedInUser,
  accountType,
  subscribedPackage,
  teamSubscribedPackage,
  teamIDCheck,
} from "../utils/store";
import Loader from "../components/Loader";
import { useNavigate } from "react-router-dom";
import LoginSchema from "../utils/SchemasValidation/LoginSchema";
import ValidateSchema from "../helpers/ValidateSchema";
import showToast from "../helpers/showToast";
import { useGoogleLogin } from "@react-oauth/google";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import { logoutFbApi, normalizePackageDetails } from "../utils/functions";
import useFunctionsCount from "../hooks/useFunctionsCount";
import { trackEvent } from "../utils/mixpanel";
import { Button } from "react-bootstrap";
import { BsLinkedin } from "react-icons/bs";

const Login = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const coupon = searchParams.get("coupon");
  let emptyObj = {
    email: "",
    password: "",
    device_type: "webapp",
    coupon_code_id: coupon || null,
  };

  const navigate = useNavigate();
  const [login, setLogin] = useState(emptyObj);

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [personalAccount, setPersonalAccount] = useAtom(accountType);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { userActions } = useFunctionsCount();
  const [purchasedPackage, setPurchasedPackage] = useAtom(subscribedPackage);
  const [teamPurchasedPackage, setTeamPurchasedPackage] = useAtom(teamSubscribedPackage);
  const [, setUserTeamId] = useAtom(teamIDCheck);

  const initializeAccountMode = (userData) => {
    const connectedTeams = userData?.connected_teams;
    const connectedTeamId = Array.isArray(connectedTeams)
      ? connectedTeams[0]?.id
      : connectedTeams?.id;

    setUserTeamId(connectedTeamId || null);
    setPersonalAccount(!connectedTeamId);
  };

  // const handleChange = (e) => {
  //   const name = e.target.name;
  //   const value = e.target.value;
  //   setLogin({ ...login, [name]: value.trim() });
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const trimmedValue = value.trim();

    // Update the input's value
    setLogin((prevLogin) => ({ ...prevLogin, [name]: trimmedValue }));

    // Validate the specific field and update errors
    const fieldErrors = ValidateSchema({ [name]: trimmedValue }, LoginSchema);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldErrors[name], // Update only the specific field's error
    }));
  };

  // handle Validation
  const validateForm = () => {
    let newErrors = ValidateSchema(login, LoginSchema);
    setErrors(newErrors);
    if (Object.keys(newErrors).length) return false;
    return true;
  };
  const getSubscriptionDetails = async (userID, userToken, userData) => {
    const payload = {
      user_id: userID,
      team_id: null,
    };
    let { status, message, data } = await post(
      GET_USER_SUBSCRIPTION,
      payload,
      userToken || null
    );

    if (status) {
      const subscription = data[0];
      const packageData = subscription?.package;
      setPurchasedPackage(packageData);
    } else {
      showToast(status, message);
    }

    // Also initialize teamPurchasedPackage from package_details if user is team owner
    if (userData?.role?.includes("team_owner") && userData?.package_details?.length > 0) {
      const teamSub = userData.package_details.find(p => p.team_id !== null && p.is_team_owner === 1)
        || userData.package_details.find(p => p.team_id !== null);
      if (teamSub) {
        const teamPkg = teamSub.package || teamSub;
        setTeamPurchasedPackage(teamPkg);
      }
    } else {
      // Clear stale team package on login for non-team-owner users
      setTeamPurchasedPackage({});
    }
  };
  const couponVal = location?.state?.couponVal;
  const isPayable = location?.state?.isPayable;
  const handleSubmit = async (e) => {
    trackEvent("Custom Form", {
      message: "Custom Form Fill up",
    });
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    let API = couponVal < 100 || coupon === null ? LOGIN : COUPON_LOGIN;
    let { status, message, data } = await post(API, login);
    if (status) {
      trackEvent(message, {
        data: data,
      });
      data = normalizePackageDetails(data);
      if (Object.keys(data).length > 0) setLoggedUser(data);
      initializeAccountMode(data);
      userActions(data);
      const role = data?.role;
      const couponData = data;
      if (data?.token && data.role[0] !== "super_admin") {
        await getSubscriptionDetails(data?.id, data?.token, data);
      }
      if (couponVal < 100 || coupon === null) {
        navigate("/", { state: { userRole: role } });
      } else {
        // if(data?.coupon?.discount === 100 && data?.subscription !== null){}
        navigate("/share/coupon-message", { state: { coupon: couponData } });
      }
    } else {
      trackEvent("Login Failed", {
        data: login,
      });
      showToast(status, message);
    }
    setLoading(false);
  };
  const handleSocialLogin = (buttonName) => {
    trackEvent(buttonName);
    loginButton(); // trigger the actual login
  };

  const loginButton = useGoogleLogin({
    onSuccess: (codeResponse) => {
      fetch(
        `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${codeResponse.access_token}`
      )
        .then((res) => {
          return res.json();
        })
        .then(async (users) => {
          return await sendSocialToken(users);
        })
        .catch((error) => {
          showToast(false, error);
          setLoading(false);
          return;
        });
    },
    onError: (err) => {
      setLoading(false);
      showToast(false, err);
    },
  });

  const sendSocialToken = async (user) => {
    setLoading(true);
    let payload = user;
    payload.first_name = user.given_name;
    payload.last_name = user.family_name;
    payload.token = user.sub;
    payload.provider_type = "google";
    payload.coupon_code_id = coupon || null;
    let { status, message, data } = await post(SOCIAL_LOGIN, payload);
    if (status) {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Successfully`,
        {
          data: data,
        }
      );
      data = normalizePackageDetails(data);
      if (Object.keys(data).length > 0) setLoggedUser(data);
      userActions(data);
      initializeAccountMode(data);
      const couponData = data;
      // console.log("daaaaa--------------", data);
      if (
        data?.is_coupon_onboarding === 1 &&
        data?.coupon?.discount === 100 &&
        !data?.coupon?.is_payable
      ) {
        navigate("/share/coupon-message", {
          state: { coupon: couponData },
        });
      } else {
        navigate("/");
      }
      // if (data.role[0] === "team_owner") {
      //   let isTeamPackage = data?.package_details.filter(
      //     (obj) => obj.team_id == data?.teams.id
      //   );

      //   let endDate = new Date(isTeamPackage[0]?.end_date);
      //   let todayDate = new Date();
      //   if (isTeamPackage.length <= 0 || todayDate >= endDate) {
      //     navigate("/paymentNotPaid");
      //     return showToast(
      //       false,
      //       "Kindly purchase package for using application"
      //     );
      //   } else {
      //     setIsOwnerPackageActive(true);
      //     navigate("/team");
      //   }
      // } else {
      //   navigate("/");
      // }
    } else {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Failed`,
        {
          data: payload,
        }
      );
      showToast(status, message);
    }
    setLoading(false);
  };

  const responseFacebook = async (response) => {
    // check error
    if (response?.error?.message) {
      showToast(false, response.error.message);
      return;
    }

    if (!response.id) {
      showToast(false, "Authentication faild");
      logoutFbApi();
      return;
    }

    setLoading(true);
    let payload = response;

    if (response?.name) {
      let dataName = handleFaceBookName(response?.name);
      if (dataName.length > 0) {
        payload.first_name = dataName["0"];
        payload.last_name = dataName?.["1"];
      }
    }

    payload.token = payload.id;
    payload.provider_type = "facebook";
    payload.coupon_code_id = coupon || null;
    delete payload.id;

    let { status, message, data } = await post(SOCIAL_LOGIN, payload);
    if (status) {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Successfully`,
        {
          data: data,
        }
      );
      data = normalizePackageDetails(data);
      if (Object.keys(data).length > 0) setLoggedUser(data);
      initializeAccountMode(data);
      userActions(data);
      const couponData = data;
      if (data?.is_coupon_onboarding === 1 && data?.coupon?.discount === 100) {
        navigate("/share/coupon-message", {
          state: { coupon: couponData },
        });
      } else {
        navigate("/");
      }
    } else {
      trackEvent(
        `${
          payload.provider_type === "google" ? "Google" : "Facebook"
        } Login Failed`,
        {
          data: data,
        }
      );
      showToast(status, message);
    }
    setLoading(false);
  };

  const handleFaceBookName = (str) => {
    if (str) {
      let lastString = str.trim().split(" ").slice(-1);
      if (lastString.length > 0) {
        let firstName = str.replace(lastString["0"], "");
        let nameArr = [];
        nameArr.push(firstName, lastString["0"]);
        return nameArr;
      }
    }
    return [];
  };

  const handleTracking = (data) => {
    trackEvent(data, {
      message: data,
    });
  };

  useEffect(() => {
    if (loggedUser?.token && coupon === null) {
      navigate("/");
    }
  }, []);
  const handleLinkedinLogin = async () => {
    setLoading(true);
    let { status, message, data } = await get(LINKEDIN_AUTH);
    if (status) {
      console.log("data-------->>>>>>>>>>>", data);

      window.open(data?.url, "_blank", "noopener,noreferrer");
    }
    setLoading(false);
  };

  return (
    <>
      <section className="auth-page">
        {!loading ? (
          <div className="container-fluid h-100">
            {/* <header>
              <nav className="navbar">
                <ul className="d-flex justify-content-between align-items-center">
                  <li>
                    <Link to="#">
                      <img src={logo} alt="logo" className="logo" />
                    </Link>
                  </li>
                  <ul className="list">
                    <li className="">
                      <Link
                        to="/signup"
                        onClick={() => handleTracking("SignUp Button Clicked")}
                      >
                        <button className="signBtn">Sign Up</button>
                      </Link>
                    </li>
                    <li>
                      <Link
                        to="/login"
                        onClick={() => handleTracking("SignIn Button Clicked")}
                      >
                        <button className="signBtn">Sign in</button>
                      </Link>
                    </li>
                  </ul>
                </ul>
              </nav>
            </header> */}

            <div className="row h-100 align-items-center">
              <div className="col-12 col-md-6 col-lg-6 d-flex justify-content-center align-items-center left-panel">
                <div className="left-panel-inner">
                  <img src={logo} alt="logo" className="logo mb-4" />
                  {/* <h1 className="heading">Hello, Welcome Back</h1> */}
                  <p className="subHeading">
                    Experience the future of networking with us, and together,
                    let’s “Connect. Share. Inspire.”
                  </p>
                </div>
              </div>
              <div className="col-12 col-md-6 col-lg-6 right-panel d-flex justify-content-center align-items-center">
                <div className="right-panel-inner">
                  <img src={logo} alt="logo" className="logo mb-4" />
                  <h1>Hello, Welcome Back</h1>
                  <p>Please enter your credentials to login.</p>

                  <div className="d-grid gap-3 social-login">
                    <Button
                      className="google-btn text-center text-decoration-none"
                      onClick={() => {
                        handleSocialLogin("Google Login Button Clicked");
                      }}
                    >
                      <img src={google} alt="Google" className="icon" /> Sign In
                      with Google
                    </Button>
                    <FacebookLogin
                      // appId="3507512309478815"
                      appId="956908413125623"
                      //appId="292102873859116" // for testing
                      autoLoad={false}
                      //fields="name,email,picture"
                      fields="name,email,birthday,picture,gender,link"
                      scope="public_profile,email,user_birthday,user_gender,user_link"
                      callback={responseFacebook}
                      render={(renderProps) => (
                        <Button
                          className="apple-btn" // onClick={renderProps.onClick}
                          onClick={() => {
                            renderProps.onClick();
                            trackEvent("Facebook Button Clicked");
                          }}
                        >
                          <img src={facebook} alt="Apple" className="icon" />{" "}
                          Sign In with Facebook
                        </Button>
                        // <button onClick={renderProps.onClick}>This is my custom FB button</button>
                      )}
                    />
                    {/* <Button
                      onClick={handleLinkedinLogin}
                      className="google-btn text-center text-decoration-none mt-0"
                    >
                      <BsLinkedin /> Login with LinkedIn
                    </Button> */}
                  </div>
                  <div className="or-devider devider-sg">
                    <span>OR</span>
                  </div>

                  <form>
                    <FormInput
                      // label="Email"
                      type="text"
                      name="email"
                      placeholder="Email Address"
                      value={login.email}
                      handleChange={handleChange}
                      error={errors?.email}
                      // icon={emailicon}
                      autofocus={true}
                    />
                    <FormInput
                      // label="Password"
                      type="password"
                      name="password"
                      placeholder="Password"
                      value={login.password}
                      handleChange={handleChange}
                      error={errors?.password}
                      // icon={lockicon}
                    />

                    <Button
                      variant="primary"
                      className="btn-block w-100"
                      type="submit"
                      onClick={handleSubmit}
                    >
                      Sign in
                    </Button>
                  </form>
                  <div className="forgotPasswordWrapper text-end mt-3 mb-4">
                    <Link to="/forgotpassword">Forgot Password ?</Link>
                  </div>
                  <div className="notAccountWrapper">
                    <p className="mb-3">Don’t have an account?</p>
                    <Link
                      to="/signup"
                      onClick={() => handleTracking("SignUp Link Clicked")}
                    >
                      <Button
                        variant="outline-primary"
                        className="btn-block w-100"
                      >
                        Sign Up
                      </Button>
                    </Link>
                  </div>
                  {/* <div className="forgotPasswordWrapper mt-3 mb-4">
                    <Link to="/forgotpassword">Privacy Policy</Link> {" | "}
                    <Link to="/forgotpassword">Terms & Conditions</Link>
                  </div> */}
                </div>

                <div className="forgotPasswordWrapper mt-3 mb-4 position-absolute bottom-0 end-0 me-4">
                  <Link to="/privacy-policy">Privacy Policy</Link> {" | "}
                  <Link to="/terms-and-service">Terms & Conditions</Link>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <Loader />
        )}
      </section>
    </>
  );
};

export default Login;
